import axios from '@/utils/fetch'
const context = '/mall';
const version = 'v1.0';
const _module = `${context}/${version}/mobile`
export default {
    homedata(data) {
        return axios({
            url: `${_module}/mobile_home`,
            method: 'POST',
            loading: false,
            data
        })
    },
    classify1() {
        return axios({
            url: `${_module}/first_mobile_classify`,
            method: 'GET',
            loading: false,
        })
    },
    classify2(pid) {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/ac43d2a8-8add-4d39-9265-f9f87b1c38b3/child_module_info?pageNum=1&pageSize=10
        return axios({
            url: `${_module}/${pid}/child_module_info`,
            method: 'GET',
            loading: false,
        })
    },
    phonebyopenId(openId) {
        //         GET /v1.0/mobile/phone/{openId}
        // 【小程序】【会员】根据openid获取手机号
        return axios({
            url: `${_module}/phone/${openId}`,
            method: 'GET',
            loading: false,
        })
    },
    about_us() {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/about_us
        // Request Method: GET
        return axios({
            url: `${_module}/about_us`,
            method: 'GET',
            loading: false,
        })
    },
    // {"content":"测试","type":1,"phone":"18149546567"}
    feed_back(data) {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/feed_back
        // Request Method: POST
        return axios({
            url: `${_module}/feed_back`,
            method: 'POST',
            data
        })
    },
    collect_service(params = { pageNum: 1, pageSize: 99 }) {
        //  GET /v1.0/mobile/collect_service
        // 【小程序】【会员】我的收藏分页列表
        // pageNum  (required) 分页数  query	integer 
        // pageSize (required) 分页大小         query	integer 
        //  serviceName	 服务名称       query	 string
        return axios({
            url: `${_module}/collect_service`,
            method: 'GET',
            loading: false,
            params
        })
    },
    collect_service_batch_cancel(ids = []) {
        // PUT /v1.0/mobile/collect_service/batch_cancel
        // 【小程序】【会员】【我的收藏列表】批量取消收藏
        // pageNum  (required) 分页数  query	integer 
        // pageSize (required) 分页大小         query	integer 
        //  serviceName	 服务名称       query	 string
        return axios({
            url: `${_module}/collect_service/batch_cancel`,
            method: 'PUT',
            data: { ids }
        })
    },
    memberCenter() {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/member/center
        // Request Method: GET
        return axios({
            url: `${_module}/member/center`,
            method: 'GET',
            loading: false,
        })
    },
    memberSetting() {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/member/setting
        // Request Method: GET
        return axios({
            url: `${_module}/member/setting`,
            method: 'GET',
            loading: false,
        })
    },
    memberSettingPut(data) {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/member/setting
        // Request Method: GET
        return axios({
            url: `${_module}/member/setting`,
            method: 'PUT',
            data
        })
    },
    // verify_mobile_code
    // verifyCode: this.data.valueVerify,
    // phone: this.data.valuePhoneNumber
    member_verify_mobile_code(data) {
        // Request URL: https://api.mall.968885.org/mall/v1.0/mobile/member/verify_mobile_code
        // Request Method: GET
        return axios({
            url: `${_module}/member/verify_mobile_code`,
            method: 'post',
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/mobile.js